import {SourcePlatform, getMsApiGatewayHostname} from '@digital-advice/ms-core-sdk';
import {Logger, Category, Severity} from '@simpleinvest/front-end-logger';
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@advisor/interceptors';

const APP_NAME = SourcePlatform.AdvisorPlatform;

export const apiKey = process.env.VUE_APP_MS_API_GATEWAY_KEY;

export const logger = new Logger({
  category: Category.RwSdkJs,
  fileName: 'sdk/index.js',
});

interface AdvisorLogger {
  error: (error: Error) => void;
  warn: (message: string) => void;
  info: (message: string) => void;
  http: (message: string) => void;
  verbose: (message: string) => void;
  debug: (message: string) => void;
  silly: (message: string) => void;
}

export const getLogger = (): AdvisorLogger => ({
  error: (error): void => logger.logException({error}),
  warn: (message): void => logger.logMessage({message, level: Severity.Warning}),
  info: (message): void => logger.addBreadcrumb({message, level: Severity.Info}),
  http: (message): void => logger.addBreadcrumb({message}),
  verbose: (message): void => logger.addBreadcrumb({message, level: Severity.Debug}),
  debug: (message): void => logger.addBreadcrumb({message, level: Severity.Debug}),
  silly: (message): void => logger.addBreadcrumb({message, level: Severity.Log}),
});

export const endpoint = getMsApiGatewayHostname();

export const interceptors = {
  requestInterceptor: requestInterceptorFulfilledHandler,
  requestRejectedInterceptor: requestInterceptorRejectedHandler,
  responseInterceptor: responseInterceptorFulfilledHandler,
  responseRejectedInterceptor: responseInterceptorRejectedHandler,
};

export const sourceInfo = {
  platform: APP_NAME,
  location: window.location.href,
};

export const resolveEndpointForServiceToken = (hasServiceToken = false): string | undefined =>
  hasServiceToken ? `${endpoint}/serviceToken` : endpoint;
